import { useObserver } from 'mobx-react';
import { useQuery } from '@apollo/client';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { GetSpecialGamificationDocument, GetSpecialGamificationQuery } from 'src/gql/graphql';
import useCart from 'hooks/use-cart';
import { toUppercaseMenuType } from 'shared/constants';

type UseSpecialGamificationProps = {
  // these should be the sourceId not the mongo id
  specialIds: string[];
  skip: boolean;
};

type UseSpecialGamificationResponse = {
  gamificationThresholds?: NonNullable<GetSpecialGamificationQuery['getSpecialGamification']>['gamificationThresholds'];
  loading: boolean;
  error?: Error;
};

export default function useSpecialGamification({
  specialIds,
  skip,
}: UseSpecialGamificationProps): UseSpecialGamificationResponse {
  const cart = useCart();
  const cartDispensary = useObserver(() => cart.dispensary);
  // Need to add a fallback for when the cart is empty
  const { dispensary: fallbackDispensary } = useDispensary();
  const dispensary = cartDispensary ?? fallbackDispensary;
  const menuType = useObserver(() => cart.menuType);
  const discountSyncEnabled = dispensary?.storeSettings?.enableLLxSaleDiscountSync;

  const skipQuery = skip || !dispensary?.id || !specialIds.length || !discountSyncEnabled;

  const { data, loading, error } = useQuery(GetSpecialGamificationDocument, {
    variables: {
      dispensaryId: dispensary?.id,
      menuType: toUppercaseMenuType(menuType),
      specialIds,
    },
    skip: skipQuery,
  });

  return {
    gamificationThresholds: data?.getSpecialGamification?.gamificationThresholds,
    loading,
    error,
  };
}
